import * as React from "react";
class CoreClickOutside extends React.PureComponent {
  _boundEvents;
  constructor(props) {
    super(props);
    this._boundEvents = [];
  }
  /**
   * Register ClickOutside events
   */
  _registerEvents() {
    const { options } = this.props;
    ["mouseup", "touchend"].forEach((eventName) => {
      document.addEventListener(eventName, this._onClickOutside, options);
      this._boundEvents.push(eventName);
    });
  }
  /**
   * Unregister ClickOutside events
   */
  _unregisterEvents() {
    const { options } = this.props;
    while (this._boundEvents.length > 0) {
      const eventName = this._boundEvents.pop();
      document.removeEventListener(eventName, this._onClickOutside, options);
    }
  }
  componentDidMount() {
    if (this.props.onClickOutside) {
      this._registerEvents();
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.onClickOutside !== prevProps.onClickOutside) {
      if (this.props.onClickOutside) {
        this._registerEvents();
      } else {
        this._unregisterEvents();
      }
    }
  }
  componentWillUnmount() {
    this._unregisterEvents();
  }
  /**
   * Check whether the click is inside the element or excluded
   * @param event - Click event
   */
  _isInsideClick = (event) => {
    const { rootRef, excludeClass } = this.props;
    let target = event.target;
    while (target) {
      if (rootRef.current === target) {
        return true;
      }
      if (target.classList) {
        if (typeof excludeClass === "string" && target.classList.contains(excludeClass)) {
          return true;
        }
        if (typeof excludeClass === "object" && target.classList.toString().split(" ").some((c) => excludeClass.includes(c))) {
          return true;
        }
      }
      target = target.parentElement;
    }
  };
  /**
   * Triggers onClickOutside callback when clicked outside child
   * @param event - Click event
   */
  _onClickOutside = (event) => {
    const { onClickOutside } = this.props;
    if (typeof onClickOutside === "function" && !this._isInsideClick(event)) {
      onClickOutside(event);
    }
  };
  render() {
    return this.props.children;
  }
}
export {
  CoreClickOutside
};
//# sourceMappingURL=CoreClickOutside.js.map
